import moment from "moment/moment";
import forms from "../../data/formulaires.json";

export default function ModalQuizReponse({ info, onClose }) {
  return (
    <div className="bg-black top-0 bottom-0 left-0 right-0 absolute bg-opacity-60 w-screen h-screen">
      <div className="flex flex-col max-w-5xl rounded-xl p-8 mx-auto mt-10 bg-palette-grey-orange">
        <div className="flex w-full justify-between items-center">
          <h1>Réponses au questionnaire</h1>
          <div onClick={onClose} className="hover:bg-palette-green hover:bg-opacity-20 cursor-pointer rounded-full p-1">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>
        <hr className="mb-10 mt-2" />
        <div className="flex w-full text-xl space-x-5 justify-between items-center px-10">
          <p className="font-bold w-full">
            {info.nom} - {info.societe}
          </p>
          <p className="whitespace-nowrap">{moment(info.date).format("DD/MM/YYYY")}</p>
          <p className="whitespace-nowrap">{forms.forms[info.formType].title}</p>
        </div>
        <div className="grid grid-cols-3 gap-3 p-10">
          {JSON.parse(info.reponse).map((group, key) => (
            <ul key={"group_" + key} className="h-full border p-4 border-palette-green rounded-lg text-left">
              <li>
                <p className="font-bold text-lg">Groupe {key + 1}</p>
              </li>
              {group.map((e, k) => (
                <li key={"group_" + key + "_res_" + k} className="flex items-center text-md justify-between w-full">
                  <p className="underline">Cas N°{k + 1} :</p> <p className="">{e.score}</p>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </div>
  );
}
